var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef, useState } from "react";
import { InvoiceDetailStyled } from "./style";
import TransactionStatus from "../../TransactionStatus/index";
import PaymentDetails from "../../PaymentDetails/index";
import InputLayout from "../../InputLayout/index";
import Button from "../../Ui/Button/index";
import { useForm } from "react-hook-form";
import ButtonLite from "../../Ui/ButtonLite/index";
import ReactToPrint from "react-to-print";
import Pdf from "./pdf";
import { ErrorMessageStyled } from "../../ErrorMsg/style";
import { useLocation, useNavigate } from "react-router-dom";
import TransactionService from "../../../services/transactionServices";
import ButtonBack from "../../ButtonBack";
import { useDispatch } from "react-redux";
import { getInvoiceClear } from "../../../redux/actions/invoiceActions";
import { getPaymentClear, getPaymentSuccess, } from "../../../redux/actions/paymentActions";
import Loading from "../../Loading/index";
import EmailServices from "../../../services/emailServices";
import config from "../../../config/enviroment";
var InvoiceDetail = function () {
    var mailServices = new EmailServices();
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var search = useLocation().search;
    var refPayco = new URLSearchParams(search).get("ref_payco");
    var componentRef = useRef(null);
    var _a = useState({}), dataResult = _a[0], setData = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), isButtonLoading = _c[0], setButtonIsLoading = _c[1];
    var _d = useState(false), isSend = _d[0], setIsSend = _d[1];
    var _e = useForm({ mode: "onChange" }), register = _e.register, errors = _e.formState.errors, handleSubmit = _e.handleSubmit, watch = _e.watch;
    var transactionService = new TransactionService();
    useEffect(function () {
        if (!sessionStorage.getItem("dataRefPago"))
            navigate("/");
        if (refPayco) {
            transactionService
                .getTransaction(refPayco)
                .then(function (data) {
                setData(data);
                dispatch(getPaymentSuccess(data));
                setIsLoading(false);
            })
                .catch(function (e) {
            });
        }
    }, []);
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setButtonIsLoading(true);
                    setIsSend(false);
                    _a = dataResult.refEpayco;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, mailServices.sendEmail(dataResult.refEpayco, data.email)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    _a;
                    setButtonIsLoading(false);
                    setIsSend(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var actionBack = function () {
        dispatch(getInvoiceClear({
            isLoading: false,
        }));
        dispatch(getPaymentClear({
            isLoading: false,
        }));
        sessionStorage.removeItem("dataRefPago");
        sessionStorage.removeItem("token");
        navigate("/");
    };
    // invoice.value && invoice.value.length > 10;
    //expresion regular para validar correo electronico
    var validateEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var validateRefOrNumber = function () {
        var valueInput = watch("email");
        if (valueInput == undefined)
            return true;
        if (valueInput == "")
            return true;
        return errors.email != null;
    };
    var cancelEventDefault = function (e) {
        e.preventDefault();
    };
    if (localStorage.getItem('typeInvoice') == 'SALES-INV') {
        dataResult.typeInvoice = 'Factura de venta' || '';
    }
    if (localStorage.getItem('typeInvoice') == 'CYCLE-INV') {
        dataResult.typeInvoice = 'Factura mensual' || '';
    }
    dataResult.total = (dataResult.balance || 0) + (dataResult.payment || 0);
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonBack, { onClick: actionBack }),
        isLoading ? (React.createElement(Loading, null)) : (React.createElement(InvoiceDetailStyled, null,
            React.createElement(TransactionStatus, { refEpayco: dataResult.refEpayco || "", nRef: dataResult.nRef || "", status: dataResult.status || "", isRefLogin: (dataResult.nRef && dataResult.nRef.length > 10) || false }),
            React.createElement(PaymentDetails, { data: dataResult }),
            React.createElement("form", { onSubmit: cancelEventDefault },
                React.createElement(InputLayout, null,
                    React.createElement("img", { src: config.urlS3 + "/wom/icons/msg.png", alt: "phone icon", className: "email-icon" }),
                    React.createElement("input", __assign({ type: "email", placeholder: "Correo electr\u00F3nico" }, register("email", {
                        required: true,
                        pattern: {
                            value: validateEmail,
                            message: "El email no es valido",
                        },
                    }))),
                    React.createElement(ButtonLite, { loading: isButtonLoading, line: isSend, disabled: validateRefOrNumber(), onClick: handleSubmit(onSubmit) }, isSend ? "ENVIADO" : "ENVIAR")),
                errors.email && (React.createElement(ErrorMessageStyled, null, "Ingresa un correo electr\u00F3nico v\u00E1lido")),
                React.createElement("div", { className: "button-container-details" },
                    React.createElement(ReactToPrint, { trigger: function () { return (React.createElement(Button, { maxWidth: 270, line: true, onClick: function () { } }, "IMPRIMIR O GUARDAR")); }, content: function () { return componentRef.current; } }),
                    React.createElement(Button, { maxWidth: 270, onClick: actionBack }, "VOLVER AL COMERCIO"))))),
        React.createElement("div", { className: "hide-pdf", ref: componentRef },
            React.createElement(Pdf, null))));
};
export default InvoiceDetail;
